export default __webpack_public_path__ + "static/media/tabla-grades.93228267.svg";